module.exports = __webpack_public_path__ + "static/flash-a59e1978c48e752539d72cab4cff6b5a.png";